import React from "react";
import "../App.css";

import service1 from "../assets/img/service_1.png";
import service2 from "../assets/img/service_2.png";
import service3 from "../assets/img/service_3.png";
import service4 from "../assets/img/service_4.png";
import service6 from "../assets/img/service_6.png";

const galleryItems = [
  {
    title: "Post Construction Cleaning",
    image: service6,
  },
  {
    title: "Residential Cleaning",
    image: service1,
  },
  {
    title: "Commercial Cleaning",
    image: service2,
  },
  {
    title: "Airbnb Cleaning",
    image: service3,
  },
  {
    title: "Carpet Cleaning and Floor Care",
    image: service4,
  },
];

const Gallery = () => {
  return (
    <div className="gallery_page">
      <div className="gallery_header">
        <h2>Gallery</h2>
        <p>
          Service highlights from Luxe Sparkle. Trusted cleaning solutions across
          Auckland with structured delivery and consistent standards.
        </p>
      </div>

      <div className="gallery_grid">
        {galleryItems.map((item) => (
          <figure className="gallery_card" key={item.title}>
            <img src={item.image} alt={item.title} />
            <figcaption>{item.title}</figcaption>
          </figure>
        ))}
      </div>
    </div>
  );
};

export default Gallery;
